import { render } from "./BusinessClubs.vue?vue&type=template&id=21906e7a"
import script from "./BusinessClubs.vue?vue&type=script&lang=js"
export * from "./BusinessClubs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__